export interface CasosTranslations {
  TABLE: {
    NAME: string;
    ACTIONS: string;
    BUTTON: string;
    BUTTON2: string;
    CASOS: string;
    NUMERO_EXPEDIENTE: string;
    FECHA_SOLICITUD: string; // Cambié de Date a string, ya que generalmente las traducciones son textos
    INCOHERENCIAS: string;
    ESTADO: string;
    ULTIMO_HITO: string;
    FECHA_FIN: string;
    TRIBUNAL: string;
  };
  // Aquí puedes añadir más secciones de traducción según lo necesites

  // Esta línea es la clave para que el objeto sea indexable por TypeScript
  [key: string]: any;  // Usamos 'any' para simplificar, pero podrías ser más específico si quieres
}

export const casosTranslations: { [language: string]: CasosTranslations } = {
  en: {
    TABLE: {
      NAME: "Name",
      ACTIONS: "Actions",
      BUTTON: "New Case",
      BUTTON2: "Download Cases",
      CASOS: "Cases",
      NUMERO_EXPEDIENTE: "Case",
      FECHA_SOLICITUD: "Submission",
      INCOHERENCIAS: "Validation",
      ESTADO: "State",
      ULTIMO_HITO: "Next milestone",
      FECHA_FIN: "Deadline",
      TRIBUNAL: "Tribunal"
    },
  },
  es: {
    TABLE: {
      NAME: "Nombre",
      ACTIONS: "Acciones",
      BUTTON: "Nuevo caso",
      BUTTON2: "Descargar Casos",
      CASOS: "Casos",
      NUMERO_EXPEDIENTE: "Caso",
      INCOHERENCIAS: "Validación",
      FECHA_SOLICITUD: "Solicitud",
      ESTADO: "Estado",
      ULTIMO_HITO: "Próximo hito",
      FECHA_FIN: "Fecha hito",
      TRIBUNAL: "Tribunal"
    },
  }
};
